import { component } from 'picoapp'
import Cookies from 'js-cookie'
import '@/lib/jquery-global.js';
import 'slick-carousel';

export default component((node, ctx) => {
  
  // const promo = jQuery('.js-promo')

  // if (Cookies.get('promo') == 'hide') {
  //   promo.hide();
  // }

  // $('.js-close-promo').on('click', function() { 
  //     Cookies.set('promo', 'hide');
  //     promo.slideUp('fast');
  // });

  //   promo.slick({
  //       dots: false,
  //       arrows: false,
  //       draggable: true,
  //       swipe: true
  //   });


})

